module.exports = __webpack_public_path__ + "img/bags.62b7e778.jpg";